<template>
    <div class="satellite-toggle">
        <button
            class="btn btn-sm"
            :class="isSatellite ? 'btn-success' : 'btn-outline-secondary'"
            @click="toggleSatellite"
            :title="isSatellite ? 'Désactiver la vue satellite' : 'Activer la vue satellite'"
        >
            <i class="fas" :class="isSatellite ? 'fa-globe-americas' : 'fa-globe'"></i>
            Vue Satellite
        </button>
    </div>
</template>

<script>
import L from 'leaflet';

export default {
    name: 'SatelliteToggle',
    props: {
        map: { type: Object, required: true }
    },
    data() {
        return {
            isSatellite: false,
            streetLayer: null,
            satelliteLayer: null
        };
    },
    methods: {
        toggleSatellite() {
            this.isSatellite = !this.isSatellite;

            if (this.isSatellite) {
                // Passer en vue satellite
                if (this.streetLayer) {
                    this.map.removeLayer(this.streetLayer);
                }
                if (this.satelliteLayer) {
                    this.satelliteLayer.addTo(this.map);
                }
            } else {
                // Passer en vue routière
                if (this.satelliteLayer) {
                    this.map.removeLayer(this.satelliteLayer);
                }
                if (this.streetLayer) {
                    this.streetLayer.addTo(this.map);
                }
            }
        }
    },
    mounted() {
        // Créer la couche satellite (ESRI World Imagery - GRATUIT)
        this.satelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.esri.com/">Esri</a>, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
        });

        // Récupérer la couche routière existante de la carte
        this.map.whenReady(() => {
            const layers = this.map._layers;
            for (const id in layers) {
                const layer = layers[id];
                if (layer instanceof L.TileLayer && !this.satelliteLayer) {
                    this.streetLayer = layer;
                    break;
                }
            }
        });
    },
    beforeUnmount() {
        // Nettoyer les couches
        if (this.satelliteLayer) {
            this.map.removeLayer(this.satelliteLayer);
        }
    }
};
</script>

<style scoped>
.satellite-toggle {
    display: inline-block;
}
</style>
